import { render } from "./SalesReportPage.vue?vue&type=template&id=81fbeaa4&scoped=true&ts=true"
import script from "./SalesReportPage.vue?vue&type=script&lang=ts"
export * from "./SalesReportPage.vue?vue&type=script&lang=ts"

import "./SalesReportPage.vue?vue&type=style&index=0&id=81fbeaa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81fbeaa4"]])

export default __exports__